export const SIM_DISCONNECTION_PRODUCTS = [
	{
		place: 'OM',
		id: 'OM_2133',
	},
	{
		place: 'OM',
		id: 'OM_2134',
	},
];

export const AAMALI_PLUS_ACCOUNT_CATEGORY = '19';

export const AAMALIPLUS = "A'AMALI+";
export const COMMITMENT_STATUS = {
	ACTIVE: 'Active',
	INACTIVE: 'Inactive',
};

export const queryParams = {
	AccountCategory: 'accountCategory',
};

export const AAMALI_PLUS_SERVICES_TAB = 'aamali-services';
export const NUMBER_DETAILS_TAB = 'number-details';

export const TARIFF_PACKAGE_NAMA = 'TARIFF_PACKAGE_NAMA';
export const FBB_ACCOUNT_CATEGORIES = ['100', '101', '102', '103', '105'];
export const AAMALI_PLUS_ACCOUNT_CATEGORIES = ['19'];
export const numberTypeCopper = 'COPPER';
export const removeProductIdsKey = ['PLAN_COMMITMENTS', 'DATA_PROVISIOINING', 'DATA_TARIFF'];
export const tarrifPlanIdKey = 'DATA_TARIFF';
export const FIBER_PRO_NOT_AVAILABLE = 'FIBER_NOT_AVAILABLE';
